import React from 'react';
import { HelpButtonProps } from './types';
import styles from './HelpButton.module.css';

export function HelpButton({ onClick, showPulse = false }: HelpButtonProps) {
  return (
    <button
      type="button"
      className={`${styles.helpButton} ${showPulse ? styles.pulse : ''}`}
      onClick={onClick}
      aria-label="Show navigation help"
      title="Camera controls (Press ? for help)"
    >
      ?
    </button>
  );
}
